import { Button as AntdButton, Table } from 'antd';
import styled from 'styled-components';

export const FilterWrapper = styled.div`
  padding: 0.5rem;
`;

export const FilterInputWrapper = styled.div`
  width: 188px;
  margin-bottom: 0.5rem;
  display: block;
`;

export const FilterSearchButton = styled(AntdButton)`
  margin-right: 0.5rem;
  width: 90px;
`;

export const FilterResetButton = styled(AntdButton)`
  width: 90px;
`;

export const ClearAllFiltersButton = styled(AntdButton)`
  z-index: 1;
  float: left;
  margin: 1rem;
`;

export const CustomizedTable = styled(Table)`
  &.ant-table-wrapper:after {
    clear: left;
  }
`;

export const iconProps = (filtered: boolean) => ({
  type: 'search',
  style: getIconStyle(filtered),
});

export const getIconStyle = (filtered: boolean) => ({
  color: filtered ? '#1890ff' : undefined,
  fontSize: '15px',
});
